export default __webpack_public_path__ + "static/media/vp1_img.4b8a86ae.jpg";